import { render, staticRenderFns } from "./transferMethod.vue?vue&type=template&id=34a83464&scoped=true"
import script from "./transferMethod.vue?vue&type=script&lang=js"
export * from "./transferMethod.vue?vue&type=script&lang=js"
import style0 from "./transferMethod.vue?vue&type=style&index=0&id=34a83464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a83464",
  null
  
)

export default component.exports